<div class="sidebar-content-root" [class.padded]="padded">
    <ng-container *ngIf="layoutSmall">
        <div class="mb-half">
            <app-user-card [user]="user"></app-user-card>
        </div>
        <div class="mb-half">
            <app-nav-items
                (clickItem)="clickItem.emit(true)"
                [items]="userItems"
                [hoverable]="!layoutSmall"
                [asBlock]="layoutSmall"
            ></app-nav-items>
        </div>
        <div nz-row class="sidebar-content-menu">
            <div nz-col>{{ 'LABELS.MENU' | translate }}</div>
        </div>
    </ng-container>
    <app-nav-items
        (clickItem)="clickItem.emit(true)"
        [items]="items"
        [hoverable]="!layoutSmall"
        [asBlock]="layoutSmall"
    ></app-nav-items>
</div>
